export const PageText = {
  _1: 'Intelligence',
  _2: 'Use the powerful aircheckr database to extract the historical, near real-time & prognosis data. Our API gives an easy access to aircheckr\'s rich database',
  _3: 'Try it out now',
  _4: 'See what the aircheckr database is worth for your organization/project/product'
};

export const Categories = {
  _1: {
    title: "Applications",
    subcategories: [
      {
        key: 0,
        subtitle: 'R&D',
        text: 'Facilitate research on air pollution and its consequences.'
      },
      {
        key: 1,
        subtitle: 'Policy',
        text: 'Monitor and fine-tune policies at different administrative levels.'
      },
      {
        key: 2,
        subtitle: 'Education',
        text: 'Educate our children about how to cope with air pollution.'
      },
      {
        key: 3,
        subtitle: 'Administration',
        text: 'Raise public awareness & start up prevention campaigns.'
      }
    ]
  },
  _2: {
    title: 'Cities',
    subcategories: [
      {
        key: 0,
        subtitle: 'Improve quality of place',
        text: 'Cities want to take their responsibility to improve quality of place for its citizens, organizations, companies and visitors. Cities want to be able to inform their citizens when the air quality is worsening and to be able to take actions wherever necessary.'
      },
      {
        key: 1,
        subtitle: 'High quality air quality data at street level',
        text: 'Developers can easily access the rich aircheckr database and integrate the air quality information into their service. Precise air quality data at street level can, on the one hand, be used to inform, sensitize and even mobilize their inhabitants and on the other hand be used internally for monitoring and fine-tuning policies.'
      }
    ]
  },
  _3: {
    title: 'Schools',
    subcategories: [
      {
        key: 0,
        subtitle: 'What’s this thing called “air pollution”?',
        text: 'We better start with our children… Teach our children what the importance of good air quality is and what we can do about it. Using the rich aircheckr database to set up an educational package for schools, bringing topics like environment, health, chemistry, physics and even IT together in a modern and joyful package. With the aircheckr data, interesting tools can be developed for teachers, students and even parents. A project could measure e.g. the air quality in the neighbourhood of the school, the trajectory to come to school for all students or measure the air quality at the students’ homes.'
      }
    ]
  }
};

export const Quotes = [{
  key: 0,
  text: 'The number of premature deaths due to the consequences of air pollution in the EU is more than ten times the toll of traffic accidents.',
  author: 'EEA, 2014'
},
{
  key: 1,
  text: 'The European Commission estimated in 2010 to have direct economic damages of 15,8 billion Euros from lost work days and 4 billion Euros from healthcare costs.',
  author: 'EEA, 2014'
}];

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/intelligence_page.js